import React, { ReactNode } from 'react';

import styles from './SettingsSection.pcss';

export interface SettingsSectionProps {
  readonly sectionHeader?: ReactNode;
  readonly sectionNote?: ReactNode;
}

const renderHeader = (sectionHeader: SettingsSectionProps['sectionHeader']) => (
  typeof sectionHeader === 'string'
    ? (
      <h6
        data-stable-name="SettingsSectionTitle"
        className={styles.title}
      >
        {sectionHeader}
      </h6>
    )
    : sectionHeader
);

export const SettingsSection: React.FC<SettingsSectionProps> = ({
  sectionHeader,
  sectionNote,
  children,
}) => (
  <>
    <div className={styles.section}>
      {sectionHeader && (
        <div
          data-stable-name="SettingsSectionHeader"
          className={styles.sectionHeader}
        >
          {renderHeader(sectionHeader)}
        </div>
      )}
      {sectionNote && (
        <p
          data-stable-name="SettingsSectionNote"
          className={styles.note}
        >
          {sectionNote}
        </p>
      )}
      {children}
    </div>
  </>
);
